import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../../core/auth.service';

@Component({
  standalone: true,
  selector: 'app-auth-callback',
  template: ``,
})
export class AuthCallbackComponent implements OnInit {
  private msalService = inject(MsalService);
  private authService = inject(AuthService);
  private router = inject(Router);

  async ngOnInit() {
    try {
      await firstValueFrom(this.msalService.handleRedirectObservable());
    } catch (err) {
      console.error('Auth callback failed', err);
      this.router.navigate(['/error'], { queryParams: { code: 401 } });
      return;
    }

    if (window.parent !== window) return;

    await this.authService.initialise();
    this.router.navigateByUrl('/app', { replaceUrl: true });
  }
}
